module.exports = __webpack_public_path__ + "img/finance-illustration-02.6e9f4f37.png";